import { gql } from "apollo-boost"

export const GET_ASSISTANTS_COUNT_BY_AGE_AND_GENDER = gql`
  query submissionAssistantsAgeRangeCounts ($submissionId: ID!){
    submissionAssistantsAgeRangeCounts(submissionId: $submissionId) {
        zeroToFive {
          total_count
          male_count
          female_count
          no_gender_count
        }
        sixToEleven {
          total_count
          male_count
          female_count
          no_gender_count
        }
        twelveToSeventeen {
          total_count
          male_count
          female_count
          no_gender_count
        }
        eightTeenToTwentyNine {
          total_count
          male_count
          female_count
          no_gender_count
        }
        thirtyToFiftyNine {
          total_count
          male_count
          female_count
          no_gender_count
        }
        moreThanSixty {
          total_count
          male_count
          female_count
          no_gender_count
        }
      }
  }
`
